import { useEffect, useState } from 'react';
import DataNotFound from '../ui/loader/data-not-found';
import InnerLoader from '../ui/loader/inner-loader';
import { useApiCall } from '../custom-hooks/api-call';
import { Link } from 'react-router';
import { ChartMainCard } from '../LeadsDashboardComponents/ChartsHeader';
import { TeamAvailability } from '../LeadsDashboardComponents/StatCardIcons';


export function RecentAccountsTable({ apiData = [], apiLoading }) {



  return (

    <ChartMainCard
      Icon={<TeamAvailability />}
      iconColor={'bg-theme-green-light text-theme-green'}
      heading="Latest Accounts"
      subHeading={"Track the most recent accounts along with deal value and progress"}
    >
      {
        !apiLoading ? (

          <div className="max-h-[430px] min-h-[430px] overflow-auto">

            {apiData.length > 0 ? (


              <table className="min-w-full">
                <thead className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Deal Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Email
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Phone
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Brand Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Deal Amount
                    </th>
                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Deal Count
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-gray-200">

                  {apiData.map((lead) => (
                    <tr key={lead.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4">
                        <h6 className="font-semibold text-sm">{lead?.name?.trim() ? lead.name : "-"}</h6>
                      </td>
                      <td className="px-6 py-4">
                        <h6 className="font-medium text-sm">{lead?.email ?? "-"}</h6>
                      </td>
                      <td className="px-6 py-4">{lead?.phone ?? "-"}</td>

                      <td className="px-6 py-4 text-sm text-gray-900">
                       {lead?.brand_name}
                      </td>

                      <td className="px-6 py-4 text-sm text-gray-600">{lead?.deal_amount}</td>
                      <td className="px-6 py-4 text-sm text-gray-600">{lead?.deal_count}</td>

                    </tr>
                  ))}




                </tbody>


              </table>


            ) : (
              <DataNotFound title={"Accounts"} />
            )}

          </div>

        ) : (
          <InnerLoader />
        )
      }
    </ChartMainCard>


  );
}
